import { c as _c } from "react/compiler-runtime";
import { isSeatSoldOut, NO_FREE_SEAT_REASON } from "@components/table/members/assign-seats/assign-seats-utils";
import { Text } from "@flat-ui";
/**
 * Returns what checking or unchecking the seat does to the seats of the workspace, that too few are
 * left for it, that the member holds it already, or that none is left to give. Nothing for a seat the member does not hold and
 * does not get.
 */
function getSeatUsage(option, isChecked, seatsAvailable, seatsUsed) {
  if (option.isHeld) {
    return isChecked ? "Assigned" : "Frees 1 seat";
  }
  if (isSeatSoldOut(option)) {
    return NO_FREE_SEAT_REASON;
  }

  // Nothing can be told about the seats the change uses while the free ones are not known
  if (!isChecked || seatsAvailable === undefined) {
    return null;
  }
  if (seatsUsed > seatsAvailable) {
    return <>
        Only <var>{seatsAvailable}</var> remaining{" "}
        {seatsAvailable === 1 ? "seat" : "seats"}
      </>;
  }
  return <>
      Uses <var>{seatsUsed}</var> of <var>{seatsAvailable}</var> remaining{" "}
      {seatsAvailable === 1 ? "seat" : "seats"}
    </>;
}

/**
 * Plain text in the corner of a seat card that tells whether the member holds the seat, how many
 * seats of the workspace checking or unchecking it uses or frees, or that none is left. It is shown
 * as an error once none is left, or once the seat is checked for more people than seats are left.
 */
export function SeatUsageText(t0) {
  const $ = _c(10);
  const {
    option,
    isChecked,
    seatsAvailable,
    seatsUsed: t1
  } = t0;
  const seatsUsed = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== isChecked || $[1] !== option || $[2] !== seatsAvailable || $[3] !== seatsUsed) {
    t2 = getSeatUsage(option, isChecked, seatsAvailable, seatsUsed);
    $[0] = isChecked;
    $[1] = option;
    $[2] = seatsAvailable;
    $[3] = seatsUsed;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const usage = t2;
  const isError = isSeatSoldOut(option) || isChecked && !option.isHeld && seatsAvailable !== undefined && seatsUsed > seatsAvailable;
  if (!usage) {
    return null;
  }
  const t3 = isError ? "error.main" : "text.secondary";
  let t4;
  if ($[5] !== t3) {
    t4 = {
      color: t3,
      flexShrink: 0,
      whiteSpace: "nowrap"
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4 || $[8] !== usage) {
    t5 = <Text variant="bodyS" component="span" sx={t4}>{usage}</Text>;
    $[7] = t4;
    $[8] = usage;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}